import {useSelector} from "react-redux";

export default function useApiRequestExecuted(requestTypeName, requestId) {
    const storedRequestId = useSelector(state => state.console[requestTypeName]);
    if (!storedRequestId || !requestId) {
        return false
    }
    return storedRequestId === requestId;
}
